import { Box } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
  height: 100%;
  margin-top: -40px;
`;

export const Content = styled(Box)`
  height: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 20px;
`;

export const FieldsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
